import { MessageTypeEnum } from "domain/enum/messageType";
import { Toast } from "primereact/toast";
import { RefObject } from "react";

/**
 * Exibe uma mensagem de toast.
 * @param toastRef A referência para o componente Toast do PrimeReact.
 * @param type O tipo de mensagem (success, error, warn, info).
 * @param summary O título da mensagem.
 * @param detail O conteúdo da mensagem.
 * @param life A duração da mensagem em milissegundos.
 */
export const showToastMessage = (
  toastRef: RefObject<Toast | null>,
  type: MessageTypeEnum,
  summary: string,
  detail: string,
  life: number = 3500
) => {
  toastRef.current?.show({
    severity: type,
    summary: summary,
    detail: detail,
    life: life,
  });
};
